var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_381_6747",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.755 9.63742H11.7791V14.1884H18.0969C17.508 17.0796 15.0451 18.7394 11.7791 18.7394C7.9241 18.7394 4.81871 15.634 4.81871 11.7791C4.81871 7.9241 7.9241 4.81871 11.7791 4.81871C13.4388 4.81871 14.938 5.40768 16.1159 6.37142L19.5425 2.94477C17.4544 1.12437 14.7774 0 11.7791 0C5.24704 0 0 5.24704 0 11.7791C0 18.3111 5.24704 23.5581 11.7791 23.5581C17.6686 23.5581 23.0227 19.2748 23.0227 11.7791C23.0227 11.083 22.9156 10.3335 22.755 9.63742Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_381_6747)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M-1.07031 18.7394V4.81866L8.03169 11.779L-1.07031 18.7394Z",
    fill: "#FBBC05"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_381_6747",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.755 9.63742H11.7791V14.1884H18.0969C17.508 17.0796 15.0451 18.7394 11.7791 18.7394C7.9241 18.7394 4.81871 15.634 4.81871 11.7791C4.81871 7.9241 7.9241 4.81871 11.7791 4.81871C13.4388 4.81871 14.938 5.40768 16.1159 6.37142L19.5425 2.94477C17.4544 1.12437 14.7774 0 11.7791 0C5.24704 0 0 5.24704 0 11.7791C0 18.3111 5.24704 23.5581 11.7791 23.5581C17.6686 23.5581 23.0227 19.2748 23.0227 11.7791C23.0227 11.083 22.9156 10.3335 22.755 9.63742Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_381_6747)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M-1.07031 4.81867L8.0317 11.779L11.7796 8.51303L24.6295 6.42491V-1.07086H-1.07031V4.81867Z",
    fill: "#EA4335"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_381_6747",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M22.755 9.63742H11.7791V14.1884H18.0969C17.508 17.0796 15.0451 18.7394 11.7791 18.7394C7.9241 18.7394 4.81871 15.634 4.81871 11.7791C4.81871 7.9241 7.9241 4.81871 11.7791 4.81871C13.4388 4.81871 14.938 5.40768 16.1159 6.37142L19.5425 2.94477C17.4544 1.12437 14.7774 0 11.7791 0C5.24704 0 0 5.24704 0 11.7791C0 18.3111 5.24704 23.5581 11.7791 23.5581C17.6686 23.5581 23.0227 19.2748 23.0227 11.7791C23.0227 11.083 22.9156 10.3335 22.755 9.63742Z",
    fill: "white"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_381_6747)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M-1.07031 18.7394L14.9921 6.42491L19.2218 6.96032L24.6295 -1.07086V24.6289H-1.07031V18.7394Z",
    fill: "#34A853"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_381_6747",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M22.755 9.63742H11.7791V14.1884H18.0969C17.508 17.0796 15.0451 18.7394 11.7791 18.7394C7.9241 18.7394 4.81871 15.634 4.81871 11.7791C4.81871 7.9241 7.9241 4.81871 11.7791 4.81871C13.4388 4.81871 14.938 5.40768 16.1159 6.37142L19.5425 2.94477C17.4544 1.12437 14.7774 0 11.7791 0C5.24704 0 0 5.24704 0 11.7791C0 18.3111 5.24704 23.5581 11.7791 23.5581C17.6686 23.5581 23.0227 19.2748 23.0227 11.7791C23.0227 11.083 22.9156 10.3335 22.755 9.63742Z",
    fill: "white"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_381_6747)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M24.6281 24.6289L8.03032 11.779L5.88867 10.1728L24.6281 4.81866V24.6289Z",
    fill: "#4285F4"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.f3a805bec972a6c42fa4aa6dd81133d8.svg";
export { ForwardRef as ReactComponent };